export interface PremiereVisiteFaqItem {
  question: string
  reponse: string
}

// Réponses officielles fournies par l'équipe pastorale du CMP Lubumbashi.
export const PREMIERE_VISITE_FAQ: PremiereVisiteFaqItem[] = [
  {
    question: 'À quelle heure dois-je arriver ? Combien de temps dure le culte ?',
    reponse:
      "Nous tenons à la ponctualité dans nos rassemblements, d'où vous pouvez arriver 30 minutes avant le début de chaque service. Tous nos cultes hebdomadaires durent 2h de temps.",
  },
  {
    question: "Comment dois-je m'habiller ?",
    reponse:
      "Vous devez vous habiller de manière décente, pour éviter d'être une pierre d'achoppement.",
  },
  {
    question: 'Où puis-je me garer ? Par où entrer ?',
    reponse:
      "Dès votre arrivée, notre service de sécurité vous guidera vers le parking, où votre véhicule sera en sécurité.",
  },
  {
    question: 'Que se passe-t-il pendant le culte ?',
    reponse:
      "Nous commençons par un moment d'adoration et de louange (des chants pour exprimer notre amour à Dieu), puis vient le moment de la prédication. Ensuite, nous donnons nos offrandes et divers dons, et enfin nous partageons les annonces.",
  },
  {
    question: 'Et mes enfants, où vont-ils ?',
    reponse:
      "Vos enfants seront entre de bonnes mains, avec nos moniteurs de l'ECODIM (École du Dimanche).",
  },
  {
    question: "Vais-je devoir donner de l'argent ?",
    reponse:
      "Vous êtes libre de donner toutes vos libéralités possibles, tant que cela vient du cœur (Malachie 3:10).",
  },
  {
    question: 'Vais-je devoir me lever et parler devant tout le monde ?',
    reponse: "Non, vous n'êtes pas censé le faire.",
  },
  {
    question: "Que faire si j'arrive en retard ?",
    reponse:
      "Vous trouverez un protocole (notre équipe d'accueil) à l'entrée, qui vous indiquera une place où vous asseoir.",
  },
]
